import * as DownloadAnalyticsHelper from '../../../../containers/download-app/helpers/DownloadAnalyticsHelper.mjs';

const getAppDownloadLinkStickyTop =
  DownloadAnalyticsHelper.getAppDownloadLinkStickyTop as (
    queryParams: Record<string, string>,
    city: string | undefined,
    isDesktop: boolean,
    currentPageRoute: string,
  ) => string;

function getURLParams(searchStr: string): Record<string, string> {
  const urlParams: Record<string, string> = {};
  searchStr.split('&').forEach(param => {
    const parts = param.split('=');
    if (parts.length >= 2) {
      urlParams[parts[0]] = parts[1];
    }
  });
  return urlParams;
}

export function getStickyDownloadLink(
  asPath: string,
  city: string | undefined,
  currentPageRoute: string,
): string {
  return getAppDownloadLinkStickyTop(
    getURLParams(asPath),
    city,
    false,
    currentPageRoute,
  );
}
